import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { combineDateTime, customTextColor } from "../../../utils/const";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Grid, MenuItem, TextField, Typography } from "@mui/material";
import styles from "../../../screens/InternalTracker/InternalTracker.module.css";
import { chnageStatusOfCandidate } from "../../../redux/post-requirement/postRequirementSlice";
import { useEffect, useState } from "react";
import { mode_of_interview } from "../../../utils/const2";
import { Box } from "@mui/system";
import { getOneSubmissionTracker } from "../../../redux/internal-tracking/InternalSubmissionSlice";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Icon } from "@iconify/react/dist/iconify.js";
import { PiUserCircleDuotone } from "react-icons/pi";

const today = new Date().toISOString().split("T")[0]; // Today's date in YYYY-MM-DD format
const maxDate = new Date();
maxDate.setDate(maxDate.getDate() + 30); // Maximum date is 30 days from today
const maxDateStr = maxDate.toISOString().split("T")[0];

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const InterviewStatusdrawer = ({
  handleClose,
  show,
  viewData,
  res,
  row,
  statusName,
}) => {
  const [btn1, setBtn1] = useState(""); // Initial text for btn1
  const [inputType, setInputType] = useState("text");
  const [isStatusChange, setIsStatusChange] = useState(false);
  const requirementStatus = useSelector(
    (state) => state.postrequirement.status
  );
  const dispatch = useDispatch();

  const handleOnClickStatusChange = () => {
    let userData = {
      candidate_status: btn1,
      requirement_candidate_tracker: res?.id,
      // interview_time:"",
      // mode_of_interview:"",
      // documentation:"",
      // rejection_reason:"",
      // feedback:""
    };
    let id = res?.id;
    dispatch(chnageStatusOfCandidate({ userData, id }));
    setIsStatusChange(true);
  };

  useEffect(() => {
    if (requirementStatus === "change_candidate_status" && isStatusChange) {
      setIsStatusChange(false);
      let id = row?.requirement;
      dispatch(getOneSubmissionTracker(id));
      handleClose();
    }
  }, [requirementStatus]);

  useEffect(() => {
    setBtn1(res?.progress[0]?.candidate_status);
    
  }, [res]);
  const formik = useFormik({
    initialValues: {
      interview_mode: null,
      interview_date: null,
      interview_time: null,
      point_of_contact: null,
      interview_note: null,
      client_name: null,
      time_zone: null,
      rejection_reason: null,
    },
    onSubmit: (values) => {
      let userData = {
        submission_status: statusName,
        // requirement_candidate_tracker: res?.internal_candidate,
        interview_time: combineDateTime(
          values?.interview_date,
          values?.interview_time
        ),
        mode_of_interview: values?.mode_of_interview,
        documentation: values?.point_of_contact,
        // rejection_reason: values?.interview_time,
        feedback: values?.interview_note,
      };
      let id = res?.submission_id;
      dispatch(chnageStatusOfCandidate({ userData, id }));
      setIsStatusChange(true);
    },
  });

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "30%",
        padding: "0 0 0 10px",
        backgroundColor: "#fafafa",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>
          <Typography>
            Requirement from: <b>{viewData?.bdm_name}</b>
          </Typography>
          {viewData?.client_name === "" ||
          viewData?.client_name === undefined ||
          viewData?.client_name === null ? (
            ""
          ) : (
            <Typography>
              Client Name: <b>{viewData?.client_name}</b>
            </Typography>
          )}
        </span>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container>
            {(statusName === "1st_ROUND_OF_INTERVIEW" ||
              statusName === "2nd_ROUND_OF_INTERVIEW" ||
              statusName === "3rd_ROUND_OF_INTERVIEW") && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <Icon
                      icon="ph:user-duotone"
                      style={{ width: "27px", height: "27px" }}
                    />
                  </Box>
                  <TextField
                    variant="standard"
                    label="Point of Contact"
                    sx={fieldStyle}
                    name="point_of_contact"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.point_of_contact}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <Icon
                      icon="solar:chat-square-call-line-duotone"
                      style={{ width: "27px", height: "27px" }}
                    />
                  </Box>
                  <TextField
                    select
                    variant="standard"
                    label="Interview Mode"
                    sx={fieldStyle}
                    name="interview_mode"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.interview_mode}
                  >
                    {mode_of_interview.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  {formik.touched.interview_mode &&
                  formik.errors.interview_mode ? (
                    <div className={styles.error}>
                      {formik.errors.interview_mode}
                    </div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <Icon
                      icon="lets-icons:date-range-duotone"
                      style={{ width: "27px", height: "27px" }}
                    />
                  </Box>
                  <TextField
                    variant="standard"
                    label="Interview Date"
                    type={inputType}
                    sx={fieldStyle}
                    name="interview_date"
                    onChange={formik.handleChange}
                    onBlur={(e) => {
                      formik.handleBlur(e);
                      setInputType("text");
                    }}
                    onClick={() => setInputType("date")}
                    inputProps={{
                      min: today,
                    }}
                    value={formik.values.interview_date}
                    error={
                      formik.touched.interview_date &&
                      Boolean(formik.errors.interview_date)
                    }
                    helperText={
                      formik.touched.interview_date &&
                      formik.errors.interview_date
                    }
                  />

                  {formik.touched.interview_date &&
                  formik.errors.interview_date ? (
                    <div className={styles.error}>
                      {formik.errors.interview_date}
                    </div>
                  ) : null}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <Icon
                      icon="solar:sort-by-time-line-duotone"
                      style={{ width: "27px", height: "27px" }}
                    />
                  </Box>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      label="Interview Time"
                      sx={fieldStyle}
                      name="interview_time"
                      onChange={(value) =>
                        formik.setFieldValue("interview_time", value)
                      }
                      value={
                        formik.values.interview_time
                          ? dayjs(formik.values.interview_time)
                          : null
                      }
                      slotProps={{
                        textField: {
                          variant: "standard",
                          error:
                            formik.touched.interview_time &&
                            Boolean(formik.errors.interview_time),
                          helperText:
                            formik.touched.interview_time &&
                            formik.errors.interview_time,
                        },
                      }}
                    />
                  </LocalizationProvider>

                  {formik.touched.interview_time &&
                  formik.errors.interview_time ? (
                    <div className={styles.error}>
                      {formik.errors.interview_time}
                    </div>
                  ) : null}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "10px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <Icon
                      icon="stash:pin-location-duotone"
                      style={{ width: "27px", height: "27px" }}
                    />
                  </Box>

                  <TextField
                    variant="standard"
                    label="Time Zone"
                    sx={fieldStyle}
                    name="time_zone"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.time_zone}
                  />
                </Grid>
              </>
            )}

            {statusName === "REJECTED" ? (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{
                  padding: "10px",
                  border: "1px solid #949494",
                  borderRadius: "3px",
                  margin: "10px",
                }}
              >
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="4"
                  placeholder="Rejection Reason"
                  name="rejection_reason"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.rejection_reason}
                  onInput={(event) => autoResize(event.target)}
                  ref={(el) => el && autoResize(el)}
                  style={{
                    overflow: "hidden",
                    resize: "none",
                    border: "none",
                    backgroundColor: "#fafafa",
                  }}
                ></textarea>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{
                  padding: "10px",
                  border: "1px solid #949494",
                  borderRadius: "3px",
                  margin: "10px",
                }}
              >
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="4"
                  placeholder={
                    statusName === "1st_ROUND_OF_INTERVIEW" ||
                    statusName === "2nd_ROUND_OF_INTERVIEW" ||
                    statusName === "3rd_ROUND_OF_INTERVIEW"
                      ? "Interview Note"
                      : "Feedback Note"
                  }
                  name="interview_note"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.interview_note}
                  onInput={(event) => autoResize(event.target)}
                  ref={(el) => el && autoResize(el)}
                  style={{
                    overflow: "hidden",
                    resize: "none",
                    border: "none",
                    backgroundColor: "#fafafa",
                  }}
                ></textarea>
              </Grid>
            )}
          </Grid>
        </form>
        <Box sx={{ textAlign: "center", marginTop: "20px" }}>
          <button
            style={{
              border: "none",
              borderRadius: "3px",
              backgroundColor: "#4287f5",
              color: "#fff",
              padding: "7px 20px",
            }}
            onClick={formik.handleSubmit}
          >
            {" "}
            Submit
          </button>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default InterviewStatusdrawer;
